import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Add } from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

const enrollmentColumns = [
  {
    field: 'name',
    headerName: 'Nome',
    flex: 1,
    minWidth: 120,
    resizable: true,
    renderCell: (params) => {
      const name = params.row.user?.name || '';
      const surname = params.row.user?.surname || '';
      const fullName = `${name} ${surname}`.trim() || 'N/A';
      const email = params.row.user?.email || '';
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body2">{fullName}</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
            {email}
          </Typography>
        </Box>
      );
    },
    valueGetter: (_, enrollment) => {
      const name = enrollment.user?.name || '';
      const surname = enrollment.user?.surname || '';
      const fullName = `${name} ${surname}`.trim() || 'N/A';
      const email = enrollment.user?.email || '';
      return `${fullName} ${email}`.toLowerCase();
    }
  },
  {
    field: 'courseName',
    headerName: 'Corso',
    flex: 1,
    minWidth: 120,
    resizable: true,
    renderCell: (params) => params.row.course?.name || '',
  },
  {
    field: 'paymentMethod',
    headerName: 'Metodo Pagamento',
    flex: 1, minWidth: 120, resizable: true,
    renderCell: (params) => {
      const methods = {
        'monthly': 'Mensile',
        'annual3': 'Annuale (3 rate)',
        'annual1': 'Annuale (1 rata)'
      };
      return methods[params.value] || params.value;
    }
  },
  {
    field: 'paymentStatus',
    headerName: 'Stato Pagamento',
    flex: 1, minWidth: 120, resizable: true,
    renderCell: (params) => { 
 
      return (
      <Chip
        label={params.row.paymentStatusInfo.isEnrollmentPaid ? 'Pagato' : 'Da Pagare'}
        color={params.row.paymentStatusInfo.isEnrollmentPaid ? 'success' : 'warning'}
        size="small"
      />
    )
  }},
  {
    field: 'amount',
    headerName: 'Importo',
    flex: 0.7, minWidth: 90, resizable: true, renderCell: (params) => `€${params.value}`
  },
  {
    field: 'createdAt',
    headerName: 'Data Iscrizione',
    flex: 0.8, minWidth: 110, resizable: true,
    renderCell: (params) => dayjs(params.value).locale('it').format('DD-MMM-YY')
  },
  // {
  //   field: 'actions',
  //   headerName: 'Azioni',
  //   flex: 1, minWidth: 120, resizable: true,
  //   renderCell: (params) => (
  //     <Box>
  //       <Button size="small" color="primary" startIcon={<Visibility />}>Dettagli</Button>
  //     </Box>
  //   )
  // }
];

const EnrolledManagementTeacher = ({ enrollments }) => {
  
  return(
  <Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6">Iscrizioni Studenti</Typography>
      <Button variant="contained" startIcon={<Add />} disabled>
        Nuova Iscrizione
      </Button>
    </Box>
    <DataGrid
      rows={enrollments}
      columns={enrollmentColumns}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25, page: 0 },
        },
      }}
      rowsPerPageOptions={[10, 25, 50]}
      autoHeight
      disableSelectionOnClick
      hideFooterPagination={enrollments.length <= 10}
    />
  </Box>
)};

export default EnrolledManagementTeacher; 